import { getApp, getApps } from "firebase/app";
import { getFirestore, Firestore } from "firebase/firestore";
import { getStorage, FirebaseStorage } from "firebase/storage";

/**
 * Get Firebase Firestore instance
 * Uses the Firebase app that was already initialized by the host application
 */
export const getDb = (): Firestore => {
  if (getApps().length === 0) {
    throw new Error(
      "Firebase not initialized. Please initialize Firebase in your main application before using ClinicCMS."
    );
  }
  const app = getApp();
  return getFirestore(app);
};

/**
 * Get Firebase Storage instance
 * Uses the Firebase app that was already initialized by the host application
 */
export const getStorageInstance = (): FirebaseStorage => {
  if (getApps().length === 0) {
    throw new Error(
      "Firebase not initialized. Please initialize Firebase in your main application before using ClinicCMS."
    );
  }
  const app = getApp();
  return getStorage(app);
};

/**
 * Check if Firebase is initialized
 */
export const isFirebaseInitialized = (): boolean => {
  return getApps().length > 0;
};

/**
 * @deprecated No longer needed - Firebase should be initialized by host app
 * Kept for backward compatibility, but does nothing
 */
export const initializeFirebase = () => {
  console.warn("initializeFirebase() is deprecated. Firebase should be initialized by the host application.");
  if (getApps().length === 0) {
    throw new Error(
      "Firebase not initialized. Please initialize Firebase in your main application before using ClinicCMS."
    );
  }
  const app = getApp();
  return { app, db: getFirestore(app), storage: getStorage(app) };
};
